import styled from 'styled-components';

const Submit = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 24px;
    margin-bottom: 16px;
    background-color: ${props => props.disabled === 'disabled' ? '#a0a0a0' : '#de0606'};
    font-size: 14px;
    font-weight: 300;
    color: #ffffff;
    cursor: ${props => props.disabled === 'disabled' ? 'not-allowed' : 'pointer'};
    &:focus {
        outline: none;
    }
`

export default Submit;


// WEBPACK FOOTER //
// ./src/User/dev/Submit.js